/* eslint-disable @typescript-eslint/no-explicit-any */
import style from "../Styles/mainSlider.module.css";
import { Link, useLocation } from "react-router-dom";
import withRole from "../Utils/withRole";
import { ClickAwayListener, Typography } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { isMobile } from "../Utils/utils";
import { useState } from "react";

function MainSlider(
  props: {
    handleFilter?: any;
    info?: any;
    open?: boolean;
  },
  location: any
) {
  location = useLocation();
  const shortLocation = location.pathname.split("/");
  const finalLocation = `/${shortLocation[1]}`;

  const [openMenuKey, setOpenMenuKey] = useState<string | null>(null);

  const sorted = [...(props?.info ?? [])].sort((a: any, b: any) =>
    (a?.orderId ?? 999) > (b?.orderId ?? 999) ? 1 : -1
  );
  const groupOrder: string[] = [];
  const groups: Record<string, any[]> = {};
  sorted.forEach((item: any) => {
    const g: string = item.group ?? "";
    if (!groups[g]) { groups[g] = []; groupOrder.push(g); }
    groups[g].push(item);
  });

  // Pin Administrare to the end
  const adminLabel = sorted.find((i: any) => i.group?.toLowerCase().includes("admin"))?.group;
  if (adminLabel) {
    const idx = groupOrder.indexOf(adminLabel);
    if (idx !== -1 && idx !== groupOrder.length - 1) {
      groupOrder.splice(idx, 1);
      groupOrder.push(adminLabel);
    }
  }

  return (
    <div>
      {!props.open ? (
        <ClickAwayListener onClickAway={isMobile() ? props.handleFilter : () => null}>
          <div className={style.container}>
            <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
              {groupOrder.map((groupName) => (
                <div key={groupName || "__ungrouped"} className={style.groupSection}>
                  {groupName ? (
                    <Typography className={style.groupLabel}>{groupName}</Typography>
                  ) : null}
                  {groups[groupName].map((element: any, key: any) => {
                    const isActive = location.pathname === element.path || finalLocation === element.path;
                    const menuKey = `${groupName}-${key}`;
                    const isOpen = openMenuKey === menuKey;

                    if (element?.subMenu) {
                      return (
                        <div key={key}>
                          <div
                            className={isActive ? style.rowSelected : style.rowItem}
                            onClick={() => setOpenMenuKey(isOpen ? null : menuKey)}
                          >
                            <span className={isActive ? style.iconSelected : style.iconNormal}>
                              {element.icon}
                            </span>
                            <Typography className={isActive ? style.selectedText : style.nonSelectedText}>
                              {element.name}
                            </Typography>
                            <KeyboardArrowDownIcon
                              className={`${style.chevron} ${isOpen ? style.chevronOpen : ""}`}
                            />
                          </div>
                          <div className={`${style.subMenuList} ${isOpen ? style.subMenuListOpen : ""}`}>
                            {element.subMenu.map((el: any) => {
                              const isSubActive = location.pathname === el.path || finalLocation === el.path;
                              return (
                                <Link
                                  key={`${el.orderId}-${el.name}`}
                                  onClick={isMobile() ? props.handleFilter : () => null}
                                  style={{ textDecoration: "none" }}
                                  className={isSubActive ? style.subRowSelected : style.subRowItem}
                                  to={el.path}
                                >
                                  <Typography className={isSubActive ? style.selectedTextMenu : style.nonSelectedTextMenu}>
                                    {el.name}
                                  </Typography>
                                </Link>
                              );
                            })}
                          </div>
                        </div>
                      );
                    }

                    return (
                      <Link
                        key={key}
                        onClick={isMobile() ? props.handleFilter : () => null}
                        style={{ textDecoration: "none" }}
                        className={isActive ? style.rowSelected : style.rowItem}
                        to={element.path}
                      >
                        <span className={isActive ? style.iconSelected : style.iconNormal}>
                          {element.icon}
                        </span>
                        <Typography className={isActive ? style.selectedText : style.nonSelectedText}>
                          {element.name}
                        </Typography>
                      </Link>
                    );
                  })}
                </div>
              ))}
            </div>
          </div>
        </ClickAwayListener>
      ) : null}
    </div>
  );
}

export default withRole(MainSlider);
